module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAUVJREFUSEvtlVGOwjAMRO09D5yBdu9VAeq9ttkzwHnWyG1cuakdHGnVL/qFlJA3HjsThIM/PJgHH+C/O95k6ff4uIkCArwg0O8fQErDOUWVhYAMIsBr7VAEuv8M51WQt7cKLEF8qK6oGx8dH4yLmPy7DnaBGhZRz3AEnBYBPtQEahgB9dEeZehcrQfdARUsTcOp173gA78AOtXPRED3UlA/PrlSE7oBalvKyvRaFsGTOffNcqEfn2StbYCizDlgp1rcsOzznFqBtT+z0qx4Z7NUMg0ntz1aUCsQyoPFlWZgrsJttuXAuwHL12Tjijs0peJiaNaBsQajNnzN16JMFStLw9dC7py2yrpnXk5G0iYUbZG0iUZhS3jPqcLVSbIYyVPN0SVnA99hz1OpRVU0P76yHnkHZW+owoAJ4S0fYNiq6MbDLX0BcbgnLBwMWbUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_8.png
// module id = xKys
// module chunks = 1